export default "__VITE_ASSET__BelGboOv__"